export function loadUser(userId) {
  return {
    type: 'LOAD_USER',
    userId,
  };
}

export function loadUserCompletion(userId, error, data) {
  return {
    type: 'LOAD_USER_COMPLETION',
    userId,
    error,
    data,
  };
}
